import axios from 'axios'

const auth = JSON.parse(localStorage.getItem('vuex'))

export function getFiles(context, id) {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common['Authorization'] = auth.auth.token_type + ' ' + auth.auth.token
    axios.get('/api/v1/files/' + id, {
      params: {
        page: context.state.pagination.current_page
      }
    })
      .then(response => {
        context.commit('SET_FILES', response.data.data)
        context.commit('SET_FILES_PAGINATION', response.data.meta)
        resolve(response)
      }).catch(e => {
      console.log(e.response);
      reject(e)
    })
  })
}

export function getFilesUser(context) {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common['Authorization'] = auth.auth.token_type + ' ' + auth.auth.token
    axios.get('/api/v1/my-files')
      .then(response => {
        context.commit('SET_USER_AUTH', response.data)
        resolve(response)
      }).catch(e => {
      console.log(e.response);
      reject(e)
    })
  })
}

export function downloadFile(context, data) {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common['Authorization'] = auth.auth.token_type + ' ' + auth.auth.token
    axios.post('/api/v1/download-files', data)
      .then(response => {
        resolve(response)
      }).catch(e => {
      console.log(e.response);
      reject(e)
    })
  })
}


export function storeFiles(context, data) {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common['Authorization'] = auth.auth.token_type + ' ' + auth.auth.token
    axios.post('/api/v1/upload-files', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
    })
      .then(response => {
        resolve(response)
      }).catch(e => {
      console.log(e.response);
      reject(e)
    })
  })
}

export function deleteFile(context, id) {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common['Authorization'] = auth.auth.token_type + ' ' + auth.auth.token
    axios.delete('/api/v1/delete-files/'+id)
      .then(response => {
        resolve(response)
      }).catch(e => {
      console.log(e);
      console.log(e.response);
      reject(e)
    })
  })
}
